bcl.s.form.validateInputStatus = function ($input, $form, callback) {
  if (!$input || !$form || $input.type === "hidden") {
    return false;
  }

  let valid;

  if (callback) {
    valid = callback($input, $form);
  } else {
    valid = $input.checkValidity();
  }

  if ($input.value) {
    if (!valid) {
      if ($input.type === "checkbox") {
        bcl.s.form.changeClassValidateInput($input, $form, 3);
        return false;
      } else if ($input.type === "radio") {
        bcl.s.form.changeClassValidateInput($input.parentNode.parentNode.firstElementChild, $form, 4);
        return false;
      } else {
        bcl.s.form.changeClassValidateInput($input, $form, 2);
        return false;
      }
    } else {
      if ($input.type === "radio") {
        bcl.s.form.changeClassValidateInput($input.parentNode.parentNode.firstElementChild, $form, 5);
        return true;
      } else {
        bcl.s.form.changeClassValidateInput($input, $form, 1);
        return true;
      }
    }
  } else if ($input.required) {
    bcl.s.form.changeClassValidateInput($input, $form, 3);
    return false;
  } else {
    bcl.s.form.changeClassValidateInput($input, $form);
    return true;
  }
};

bcl.s.form.changeClassValidateInput = function ($input, $form, status) {
  const method = "removeClass";

  bcl.u[method]($input, bcl.s.form.props.classNameInputInvalid);
  bcl.u[method]($input, bcl.s.form.props.classNameInputValid);
  bcl.u[method]($input.parentNode, bcl.s.form.props.classNameEmptyInvalid);
  bcl.u[method]($input.parentNode, bcl.s.form.props.classNameErrorInvalid);

  if (!status) {
    return;
  }

  if (status === 1) {
    //valid
    if ($input.type === "email" || $input.type === "tel") {
      bcl.u.addClass($input, bcl.s.form.props.classNameInputValid);
    }
    return;
  }

  if (status === 4) {
    bcl.u.addClass($input, bcl.s.form.props.classNameEmptyInvalid);
    return;
  } else if (status === 5) {
    bcl.u.removeClass($input, bcl.s.form.props.classNameEmptyInvalid);
    bcl.u.addClass($input, bcl.s.form.props.classNameInputValid);
    return;
  }

  bcl.u.addClass($input, bcl.s.form.props.classNameInputInvalid);

  if (status === 2) {
    //invalid
    bcl.u.addClass($input.parentNode, bcl.s.form.props.classNameErrorInvalid);
    return;
  }

  bcl.u.addClass($input.parentNode, bcl.s.form.props.classNameEmptyInvalid);
};

bcl.s.form.emailValidate = function ($input) {
  if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.test($input.value)) {
    return false;
  }

  return true;
};

bcl.s.form.telValidate = function ($input) {
  return bcl.s.intlTelInput.validatePhone($input);
};

bcl.s.form.fileValidate = function ($input) {
  const maxSize = $input.getAttribute("data-max-size");

  if ($input.files.length) {
    let fileSize = 0;
    let invalidFile = false;

    for (let i = 0; i < $input.files.length; i++) {
      fileSize += $input.files[i].size;
      if (!bcl.c.helpForms.validationFormFiles($input.files[i].name)) {
        invalidFile = true;
      }
    }

    if (fileSize > maxSize || invalidFile) {
      const divFile = bcl.u.closest($input, "div");
      const divMessageGeneralError = divFile?.querySelector(".c-input-error-message");
      if (divMessageGeneralError) {
        divMessageGeneralError.innerText = "";
      }
      return false;
    }
  } else if ($input.required) {
    return false;
  }

  return true;
};

bcl.s.form.numberValidate = function ($input) {
  if (!/^[0-9]+$/.test($input.value)) {
    return false;
  }

  return true;
};

bcl.s.form.inputTypeValidity = function ($input, $form) {
  let callback;

  if ($input.type == "email") {
    callback = bcl.s.form.emailValidate;
  } else if ($input.type == "tel") {
    callback = bcl.s.form.telValidate;
  } else if ($input.type == "file" && $input.getAttribute("data-max-size")) {
    callback = bcl.s.form.fileValidate;
  } else if ($input.type == "number") {
    callback = bcl.s.form.numberValidate;
  }

  if (callback || $input.type === "text" || $input.type === "textarea" || $input.type === "checkbox" || $input.type === "select-one" || $input.type == "radio") {
    return bcl.s.form.validateInputStatus($input, $form, callback);
  }

  return true;
};

bcl.s.form.inputCustomValidity = function () {
  return false;
};

bcl.s.form.formReservationMValidity = function ($input, $form) {
  let status = true;

  if ($input.id == "rm-comment") {
    if ($input.value == "") {
      if ($form.querySelector("#rm-booking-mod") && $form.querySelector("#rm-booking-mod").checked) {
        $input.setAttribute("required", "");
        const $label = bcl.s.form.getLabel($input, $form);
        if ($label.length > 0) {
          bcl.u.addClass($label[0], "required");
        }
      } else if ($form.querySelector("#rm-booking-delete") && $form.querySelector("#rm-booking-delete").checked && $form.querySelector("#rm-reason-booking").value == $form.querySelector("#rm-reason-booking").length - 1) {
        $input.setAttribute("required", "");
        const $label = bcl.s.form.getLabel($input, $form);
        if ($label.length > 0) {
          bcl.u.addClass($label[0], "required");
        }
      } else {
        $input.removeAttribute("required");
        const $label = bcl.s.form.getLabel($input, $form);
        if ($label.length > 0) {
          bcl.u.removeClass($label[0], "required");
        }
      }
    }

    return bcl.s.form.inputTypeValidity($input, $form);
  } else if ($input.id == "rm-reason-booking") {
    if ($input.value == "" && $form.querySelector("#rm-booking-delete") && $form.querySelector("#rm-booking-delete").checked) {
      status = false;
    }

    return bcl.s.form.statusConditionForm($input, $form, status);
  }

  return bcl.s.form.inputTypeValidity($input, $form);
};

bcl.s.form.getLabel = function ($input) {
  const $parent = $input.parentNode;
  if ($parent.getElementsByTagName("label") != null) {
    return $parent.getElementsByTagName("label");
  }
  return;
};

bcl.s.form.statusConditionForm = function ($input, $form, status) {
  if (status) {
    return bcl.s.form.inputTypeValidity($input, $form);
  }

  bcl.s.form.changeClassValidateInput($input, $form);

  return true;
};

bcl.s.form.formReservationCValidity = function ($input, $form) {
  let status = true;

  if ($input.id == "rc-info-category") {
    if ($input.value == "" && $form.querySelector("#rc-info") && $form.querySelector("#rc-info").checked) {
      status = false;
    }

    return bcl.s.form.statusConditionForm($input, $form, status);
  } else if ($input.id == "rc-comments-category") {
    if ($input.value == "" && $form.querySelector("#rc-comments") && $form.querySelector("#rc-comments").checked) {
      status = false;
    }

    return bcl.s.form.statusConditionForm($input, $form, status);
  } else if ($input.id == "rc-hotel") {
    if (
      ($input.value == "" && $form.querySelector("#rc-info") && $form.querySelector("#rc-info").checked && ($form.querySelector("#rc-info-category").value == "reserva" || $form.querySelector("#rc-info-category").value == "hotel")) ||
      ($form.querySelector("#rc-comments") && $form.querySelector("#rc-comments").checked && ($form.querySelector("#rc-comments-category").value == "estancia" || $form.querySelector("#rc-comments-category").value == "hotel"))
    ) {
      status = false;
    }

    return bcl.s.form.statusConditionForm($input, $form, status);
  } else if ($input.id == "rc-loc" || $input.id == "rc-booking-where") {
    if (
      ($input.value == "" && $form.querySelector("#rc-info") && $form.querySelector("#rc-info").checked && $form.querySelector("#rc-info-category").value == "reserva") ||
      ($form.querySelector("#rc-comments") && $form.querySelector("#rc-comments").checked && $form.querySelector("#rc-comments-category").value == "estancia")
    ) {
      status = false;
    }

    return bcl.s.form.statusConditionForm($input, $form, status);
  }

  return bcl.s.form.inputTypeValidity($input, $form);
};

bcl.s.form.formClaimSValidity = function ($input, $form) {
  let status = true;

  if ($input.id == "cs-category") {
    if ($input.value == "" && $form.querySelector("#cs-other-themes") && $form.querySelector("#cs-other-themes").checked) {
      status = false;
    }

    return bcl.s.form.formReservationCValidity($input, $form, status);
  } else if ($input.id == "cs-hotel") {
    if (
      $input.value == "" &&
      (($form.querySelector("#cs-booking") && $form.querySelector("#cs-booking").checked) ||
        ($form.querySelector("#cs-other-themes") &&
          $form.querySelector("#cs-other-themes").checked &&
          ($form.querySelector("#cs-category").value == "hotel" || $form.querySelector("#cs-category").value == "reserva" || $form.querySelector("#cs-category").value == "refound")))
    ) {
      status = false;
    }

    return bcl.s.form.formReservationCValidity($input, $form, status);
  } else if ($input.id == "cs-loc" || $input.id == "cs-booking-where") {
    if (
      $input.value == "" &&
      (($form.querySelector("#cs-booking") && $form.querySelector("#cs-booking").checked) ||
        ($form.querySelector("#cs-other-themes") && $form.querySelector("#cs-other-themes").checked && ($form.querySelector("#cs-category").value == "reserva" || $form.querySelector("#cs-category").value == "refound")))
    ) {
      status = false;
    }

    return bcl.s.form.formReservationCValidity($input, $form, status);
  }

  return bcl.s.form.inputTypeValidity($input, $form);
};

bcl.s.form.checkAlmostOne = function ($form) {
  let $inputs = $form.querySelectorAll("input, textarea");
  const groupChecked = [];

  bcl.u.forEach($inputs, function ($input) {
    if (($input.type == "checkbox" || $input.type == "textarea") && $input.getAttribute("data-almostone")) {
      if (($input.type == "checkbox" && $input.checked == true) || ($input.type == "textarea" && $input.value != "")) {
        if (groupChecked.length == 0 || (groupChecked.length > 0 && !groupChecked.includes($input.getAttribute("data-almostone")))) {
          groupChecked.push($input.getAttribute("data-almostone"));
        }
      } else {
        $input.setCustomValidity("Invalid field.");
        bcl.u.addClass($input, $input.getAttribute("data-almostone"));
        bcl.u.addClass($input, "errorValidationAlmostOne");
      }
    }
  });

  bcl.u.forEach(groupChecked, function ($input) {
    $inputs = $form.querySelectorAll("." + $input);
    bcl.u.forEach($inputs, function ($input) {
      $input.setCustomValidity("");
      bcl.u.removeClass($input, $input.getAttribute("data-almostone"));
      bcl.u.removeClass($input, "errorValidationAlmostOne");
    });
  });

  if ($form.querySelector(".errorValidationAlmostOne")) {
    bcl.u.addClass($form, bcl.s.form.props.classErrorValidationForm);
  }
};
